<fgb-banner [pageTitle]="'terms.page.title' | translate" />
<fgb-page-header [pageTitle]="'terms.page.title'" [showBalance]="false"/>
<div class="container">
  <div class="row">
    <div class="col-12">
      <div class="pt-lg-4">
        <fgbcl-terms-and-conditions [type]="termsAndConditionsType" [defaultTerms]="defaultTemplate"></fgbcl-terms-and-conditions>
      </div>
    </div>
  </div>
</div>

<ng-template #defaultTemplate>
  <p class="terms-section-content text-start mb-3">Loading...</p>
</ng-template>
